import { Pause, Play } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import UDText from 'ud-ui/components/text';

import { DivProps } from '../../../../../typings';
import { millisToMinutesAndSeconds } from '../../../domain/utils/convert-time';
import { selectPopup } from '../../../store/overlay/selectors';
import { setPeriod, toggleTimer } from '../../../store/time/time';
import useTime from '../../hooks/use-time';
import useTimer from '../../hooks/use-timer';
import ValueBlock from '../components/value-block';
import Counter from './counter';
import { CountButton, PanelItemWrapper, PlayerController } from './styles';

function Period(props: DivProps) {
  const { className = '', style, ...rest } = props;
  const dispatch = useDispatch();
  const { period } = useTime();
  const { timer, setTimer, addToTimer, isActive } = useTimer();
  const popup = useSelector(selectPopup);

  const onClickToggler = () => {
    dispatch(toggleTimer());
    popup?.postMessage(JSON.stringify({ type: 'toggleTimer', isActive: !isActive }));
  };

  const onChangePeriod = (num: number) => {
    setTimer(0);
    dispatch(setPeriod(num));
    popup?.postMessage(JSON.stringify({ type: 'setPeriod', period: num }));
  };

  const handleAddToTimer = (num: number) => {
    addToTimer(num);
    popup?.postMessage(JSON.stringify({ type: 'setTimer', milliseconds: timer + num }));
  };

  return (
    <PanelItemWrapper className={'flex-center flex-col ' + className} style={{ gap: 6, maxHeight: 122, ...style }} {...rest}>
      <UDText style={{ flexGrow: 1 }} type={'headline'} color={'#686A79'}>
        Тайм
      </UDText>
      <div className={'flex items-center'} style={{ width: '100%', height: 30, justifyContent: 'space-between', gap: 10 }}>
        <PlayerController className={'flex-center'} onClick={onClickToggler}>
          {isActive ? <Pause size={20} fill={'white'} color={'white'} /> : <Play size={20} fill={'white'} color={'white'} />}
        </PlayerController>
        <Counter value={period} setValue={onChangePeriod} />
        <ValueBlock
          text={millisToMinutesAndSeconds(timer)}
          textSize={'large'}
          className={'flex-center'}
          style={{ width: 70, height: 30 }}
        />
      </div>
      <div className={'flex flex-row justify-between'} style={{ gap: 4, width: '100%' }}>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(-10 * 1000)}>
          -10
        </CountButton>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(-5 * 1000)}>
          -5
        </CountButton>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(-1 * 1000)}>
          -1
        </CountButton>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(1000)}>
          +1
        </CountButton>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(5 * 1000)}>
          +5
        </CountButton>
        <CountButton style={{ fontSize: 8, color: '#686A79' }} onClick={() => handleAddToTimer(10 * 1000)}>
          +10
        </CountButton>
      </div>
    </PanelItemWrapper>
  );
}

export default Period;
